var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-0 flex flex-wrap"},[(!_vm.selectedWaTemplate)?_c('templates-picker',{attrs:{"inbox-id":_vm.inboxId},on:{"onSelect":_vm.pickTemplate}}):_c('template-parser',{ref:"parser",attrs:{"template":_vm.selectedWaTemplate,"show-actions":_vm.showActions},on:{"resetTemplate":_vm.onResetTemplate,"sendMessage":_vm.onSendMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }